/**
 * V3: FAQs / Accordions
 *
 * @module modules/V3FAQs
 * @module modules/V3Careers
 */


// Dependencies
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	const $container = $( '[data-v3-faqs]' );

	if ( !$container.length )
	{
		return;
	}

	setup( $container.hasClass( 'js-faqs-single' ) );
}


function setup( single_accordions )
{
	const $links = $( '.v3-accordions__accordion__header > a:not(.v3-btn)' );
	const single_mode = single_accordions || false;

	$links.on( 'click', function ( event )
	{
		event.stopPropagation();
		event.preventDefault();

		const $accordion = $( this ).parents( '.v3-accordions__accordion' );

		if ( $accordion.hasClass( 'js-accordion-active' ) )
		{
			$accordion.removeClass( 'js-accordion-active' );
		}
		else
		{
			$accordion.addClass( 'js-accordion-active' );
		}

		if ( single_mode )
		{
			$accordion.siblings( '.v3-accordions__accordion' ).removeClass( 'js-accordion-active' );
		}
	});
}


// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
